import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { requiredRule } from '@utils/rules'
import { Alert, DatePicker, Form } from 'antd'
import { RangePickerProps } from 'antd/es/date-picker'
import dayjs from 'dayjs'
import { Localizable } from '../../localizable/Localizable'

const { RangePicker } = DatePicker

export const disabledDate: RangePickerProps['disabledDate'] = (current) =>
  current.isBefore(dayjs(), 'day')

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Localizable.Input
        name="title"
        rules={[requiredRule()]}
        label={'Title'}
        max={45}
      />
      <Form.Item name="dates" rules={[requiredRule()]} label={'Dates'}>
        <RangePicker className="w-full" disabledDate={disabledDate} />
      </Form.Item>
      <Form.Item name="venues" rules={[requiredRule()]} label={'Venues'}>
        <SBAsyncSelect
          entity={Entity.venue}
          searchFieldName="name"
          allowClear
          multiple
        />
      </Form.Item>
      <Alert
        title="Warning: Please ensure the selected date range does not overlap with an existing one."
        type="warning"
        showIcon
      />
    </Form>
  )
}

export default Create
